import { render } from "./AdminMixins.vue?vue&type=template&id=99a3dd2a"
import script from "./AdminMixins.vue?vue&type=script&lang=js"
export * from "./AdminMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__